(function () {
  function normalizeText(value) {
    const baseValue = value || '';

    if (typeof baseValue.normalize === 'function') {
      return baseValue
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\u00a0/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    }

    return baseValue.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function parseDescription(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html || '', 'text/html');
    const text = (doc.body.textContent || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\r/g, '\n')
      .replace(/[ \t]+\n/g, '\n')
      .replace(/\n{2,}/g, '\n')
      .trim();

    return text
      .split('\n')
      .map(function (line) {
        return line.trim();
      })
      .filter(Boolean);
  }

  function extractValue(lines, labels) {
    for (let i = 0; i < lines.length; i += 1) {
      const line = lines[i];
      const normalizedLine = normalizeText(line);

      for (let j = 0; j < labels.length; j += 1) {
        const label = labels[j];
        if (!normalizedLine.startsWith(label)) continue;

        const separatorIndex = line.indexOf(':');
        const inlineValue = separatorIndex >= 0 ? line.slice(separatorIndex + 1).trim() : '';
        if (inlineValue) return inlineValue;

        if (lines[i + 1]) return lines[i + 1].trim();
      }
    }

    return 'Consultar';
  }

  function inferIdeal(product) {
    const handle = product.handle || '';

    if (handle.includes('delta-3-pro')) return 'Respaldo avanzado del hogar y cargas exigentes.';
    if (handle.includes('delta-3')) return 'Hogar moderno con cortes frecuentes y mas autonomia.';
    if (handle.includes('delta-2')) return 'Refrigerador, internet y equipos clave de la casa.';
    if (handle.includes('river') && handle.includes('pro')) return 'Movilidad con mas autonomia para uso diario.';
    if (handle.includes('river') && handle.includes('max')) return 'Subir desde RIVER basica sin pasar aun a DELTA.';
    if (handle.includes('river')) return 'Router, luces, laptops y emergencias basicas.';

    return 'Consultar con un asesor segun el uso en Cuba.';
  }

  function getKnownProfile(product) {
    const handle = normalizeText(product.handle || '');

    if (handle.includes('delta-3-pro') || handle.includes('delta-pro-3')) {
      return {
        capacity: '4096Wh',
        output: '4000W',
        charge: 'Carga rapida AC',
        ideal: 'Hogar completo, cargas exigentes y respaldo premium.'
      };
    }

    if (handle.includes('delta-3')) {
      return {
        capacity: '1024Wh',
        output: '1800W',
        charge: 'Carga rapida AC',
        ideal: 'Refrigerador, TV, router y respaldo serio del hogar.'
      };
    }

    if (handle.includes('delta-2-max')) {
      return {
        capacity: '2048Wh',
        output: '2400W',
        charge: 'Carga rapida AC',
        ideal: 'Cortes largos, mas autonomia y cargas del hogar.'
      };
    }

    if (handle.includes('delta-2')) {
      return {
        capacity: '1024Wh',
        output: '1800W',
        charge: 'Carga rapida AC',
        ideal: 'Refrigerador, ventilador, TV y equipos clave de la casa.'
      };
    }

    if (handle.includes('river-2-pro') || handle.includes('river-pro-2')) {
      return {
        capacity: '768Wh',
        output: '800W',
        charge: 'Carga rapida AC',
        ideal: 'Movilidad con mas autonomia y respaldo ligero del hogar.'
      };
    }

    if (handle.includes('river-2-max')) {
      return {
        capacity: '512Wh',
        output: '500W',
        charge: 'Carga rapida AC',
        ideal: 'Ventilador, TV pequeno, router y luces con mas margen.'
      };
    }

    if (handle.includes('river-2')) {
      return {
        capacity: '256Wh',
        output: '300W',
        charge: 'Carga rapida AC',
        ideal: 'Router, luces, laptops y emergencias basicas.'
      };
    }

    return null;
  }

  function formatMoney(value) {
    const amount = Number(value || 0);
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }).format(amount);
  }

  function buildSpecs(product) {
    const knownProfile = getKnownProfile(product);
    if (knownProfile) {
      return {
        family: product.family || product.type || 'EcoFlow',
        capacity: knownProfile.capacity,
        output: knownProfile.output,
        charge: knownProfile.charge,
        ideal: knownProfile.ideal,
        price: formatMoney(product.price),
      };
    }

    const lines = parseDescription(product.descriptionHtml);

    return {
      family: product.family || product.type || 'EcoFlow',
      capacity: extractValue(lines, ['capacidad', 'capacidad tecnica']),
      output: extractValue(lines, ['potencia', 'potencia de salida', 'potencia de salida continua']),
      charge: extractValue(lines, ['tiempo de carga', 'tiempo de carga completa', 'carga de pared']),
      ideal: inferIdeal(product),
      price: formatMoney(product.price),
    };
  }

  function updatePanel(panel, product, specs, currentHandle) {
    const image = panel.querySelector('[data-versus-image]');

    if (image) {
      image.src = product.image || image.src;
      image.alt = product.title;
    }

    const family = panel.querySelector('[data-versus-family]');
    const title = panel.querySelector('[data-versus-title]');
    const subtitle = panel.querySelector('[data-versus-subtitle]');
    const price = panel.querySelector('[data-versus-price]');
    const link = panel.querySelector('[data-versus-link]');
    const current = panel.querySelector('[data-versus-current]');

    if (family) family.textContent = product.family || 'EcoFlow';
    if (title) title.textContent = product.title;
    if (subtitle) subtitle.textContent = product.subtitle || 'Energia premium para el hogar cubano.';
    if (price) price.textContent = specs.price;
    if (link) link.href = product.url;
    if (current) current.hidden = product.handle !== currentHandle;

    panel.classList.toggle('is-current-product', product.handle === currentHandle);

    panel.querySelectorAll('[data-versus-spec]').forEach(function (item) {
      const key = item.getAttribute('data-versus-spec');
      if (specs[key]) item.textContent = specs[key];
    });
  }

  function initializeSection(section) {
    if (!section) return;

    const dataScript = section.querySelector('[data-versus-products]');
    if (!dataScript) return;

    let products = [];

    try {
      products = JSON.parse(dataScript.textContent || '[]');
    } catch (error) {
      console.error('No se pudo leer la data del versus EcoFlow.', error);
      return;
    }

    if (!products.length) return;

    const selects = Array.from(section.querySelectorAll('[data-versus-select]'));
    const panels = Array.from(section.querySelectorAll('[data-versus-panel]'));
    const cells = {
      family: Array.from(section.querySelectorAll('[data-versus-row="family"]')),
      capacity: Array.from(section.querySelectorAll('[data-versus-row="capacity"]')),
      output: Array.from(section.querySelectorAll('[data-versus-row="output"]')),
      charge: Array.from(section.querySelectorAll('[data-versus-row="charge"]')),
      ideal: Array.from(section.querySelectorAll('[data-versus-row="ideal"]')),
      price: Array.from(section.querySelectorAll('[data-versus-row="price"]')),
    };

    const currentHandle = section.dataset.currentProduct || '';

    function updateSlot(slotIndex) {
      const selectedHandle = selects[slotIndex] ? selects[slotIndex].value : '';
      const product =
        products.find(function (item) {
          return item.handle === selectedHandle;
        }) || products[0];

      const specs = buildSpecs(product);
      const panel = panels[slotIndex];

      if (panel) updatePanel(panel, product, specs, currentHandle);

      if (cells.family[slotIndex]) cells.family[slotIndex].textContent = specs.family;
      if (cells.capacity[slotIndex]) cells.capacity[slotIndex].textContent = specs.capacity;
      if (cells.output[slotIndex]) cells.output[slotIndex].textContent = specs.output;
      if (cells.charge[slotIndex]) cells.charge[slotIndex].textContent = specs.charge;
      if (cells.ideal[slotIndex]) cells.ideal[slotIndex].textContent = specs.ideal;
      if (cells.price[slotIndex]) cells.price[slotIndex].textContent = specs.price;
    }

    const handles = products.map(function (item) {
      return item.handle;
    });

    const defaults = [];
    if (currentHandle && handles.includes(currentHandle)) defaults.push(currentHandle);

    handles.forEach(function (handle) {
      if (!defaults.includes(handle) && defaults.length < selects.length) {
        defaults.push(handle);
      }
    });

    while (defaults.length < selects.length) {
      defaults.push(handles[0]);
    }

    selects.forEach(function (select, index) {
      select.value = defaults[index] || products[0].handle;

      if (select.dataset.versusBound !== 'true') {
        const handler = function () {
          updateSlot(index);
        };

        select.addEventListener('change', handler);
        select.addEventListener('input', handler);
        select.dataset.versusBound = 'true';
      }

      updateSlot(index);
    });
  }

  function initialize(root) {
    root.querySelectorAll('[data-ecoflow-versus]').forEach(initializeSection);
  }

  function runInitialize() {
    initialize(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runInitialize);
  } else {
    runInitialize();
  }

  window.addEventListener('pageshow', runInitialize);

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
